//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getImUserSelector } from '@/api/permission/user';
export default {
  name: 'UserBox',
  props: {
    title: {
      type: String,
      default: '审批人'
    }
  },
  data: function data() {
    return {
      visible: false,
      id: '',
      nodeId: '0',
      props: {
        children: 'children',
        label: 'fullName',
        value: 'id',
        isLeaf: 'isLeaf'
      },
      treeData: [],
      loading: false,
      keyword: ''
    };
  },
  methods: {
    init: function init() {
      this.visible = true;
      this.keyword = '';
      this.nodeId = '0';
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      this.loading = true;
      if (this.keyword) this.nodeId = '0';
      getImUserSelector(this.nodeId, this.keyword).then(function (res) {
        _this.treeData = res.data.list;
        _this.loading = false;
      });
    },
    loadNode: function loadNode(node, resolve) {
      if (node.level === 0) {
        this.nodeId = '0';
        return resolve(this.treeData);
      }
      this.nodeId = node.data.id;
      getImUserSelector(this.nodeId).then(function (res) {
        resolve(res.data.list);
      });
    },
    handleNodeClick: function handleNodeClick(data) {
      if (data.type !== 'user') return;
      this.id = data.id;
    },
    dataFormSubmit: function dataFormSubmit() {
      if (!this.id) {
        this.$message({
          message: "\u8BF7\u9009\u62E9".concat(this.title),
          type: 'error',
          duration: 1000
        });
        return;
      }
      this.visible = false;
      this.$emit('submit', this.id);
    }
  }
};